<template>
  <div class="p-config-contract-organization">
    <div class="p-config-contract-organization__content">
      <table class="c-table">
        <tbody>
          <tr>
            <td>
              <Loading v-if="usages.isLoading" variant="inline" />
              <template v-else-if="usages.request.error">
                {{ usages.request.error }}
              </template>
              <template v-else-if="!Object.keys(usages.data.items).length">
                -
              </template>
              <ul v-else class="p-config-contract-usages">
                <ListItemUsage
                  v-if="usages.data.items['projects']"
                  label="サイト登録数"
                  :current="usages.data.items['projects'].current"
                  :max="usages.data.items['projects'].max"
                  hasGraph
                />
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ListItemUsage from '@/components/config/ListItemUsage';
import Loading from '@/components/Loading';
import apiUsages from '@/api/usages';
import axios from 'axios';

export default {
  components: {
    ListItemUsage,
    Loading
  },
  data() {
    return {
      cancelToken: null,
      usages: {
        data: {
          items: {}
        },
        request: {
          error: ''
        },
        isLoading: true
      }
    };
  },
  created() {
    this.getUsages();
  },
  beforeDestroy() {
    if (this.cancelToken) {
      this.cancelToken.cancel();
    }
  },
  methods: {
    getUsages() {
      const params = {
        items: 'projects',
        projects: 'all'
      };
      this.cancelToken = axios.CancelToken.source();

      return apiUsages
        .get(params, this.auth.idToken, this.cancelToken.token)
        .then(response => {
          this.usages.data.items = response.data.items.reduce((acc, cur) => {
            acc[cur.name] = cur;
            return acc;
          }, {});
          this.usages.isLoading = false;
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            if (error.response && error.response.data) {
              this.usages.request.error =
                error.response.data.errors[0].userMessage;
            }
            this.usages.isLoading = false;
          }
        });
    }
  }
};
</script>
